import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private httpRequestCounter: number = 0;

  constructor() { }

  public addRequest(): void {
    this.httpRequestCounter++;
  }

  public removeRequest(): void {
    this.httpRequestCounter--;
  }

  public isLoaderVisible(): boolean {
    return this.httpRequestCounter > 0;
  }

}
